import { HttpMethods, RestRequest, RestResponse } from '@maverick/http';
import { SourceApps } from '@maverick/entity';
import { createApiClient } from './client';

const apiVersion = 'v1.1';

interface GetBasketParams {
    basketId: string;
}

export class CheckoutService {
    private readonly apiClient;

    constructor(sourceApp: SourceApps) {
        this.apiClient = createApiClient(sourceApp);
    }

    async getBasket(params: GetBasketParams): Promise<RestResponse> {
        const request = new RestRequest({
            method: HttpMethods.Get,
            endpoint: `${apiVersion}/baskets/${params.basketId}`,
        });
        return this.apiClient.ExecuteRequest(request);
    }
}
